import React from 'react';
import SEOHead from '../components/seo/SEOHead';
import Breadcrumb from '../components/seo/Breadcrumb';
import ContactForm from '../components/landing/ContactForm';
import { useLocation } from 'react-router-dom';
import { isEnglishPath } from '../utils/i18nRoutes';

const ALTERNATES = [
  { hreflang: 'es', href: '/contacto' },
  { hreflang: 'en', href: '/en/contact' },
  { hreflang: 'x-default', href: '/contacto' },
];

const TEXT = {
  es: {
    seoTitle: 'Contacto | Valoriza Innovation Hub',
    seoDescription: 'Cuéntanos una tecnología, un reto o una colaboración. El equipo de innovación de Valoriza responde en 2 días laborables.',
    breadcrumb: [{ label: 'Inicio', to: '/' }, { label: 'Contacto' }],
  },
  en: {
    seoTitle: 'Contact | Valoriza Innovation Hub',
    seoDescription: 'Tell us about a technology, a challenge or a collaboration. Valoriza\u2019s innovation team replies within 2 business days.',
    breadcrumb: [{ label: 'Home', to: '/en' }, { label: 'Contact' }],
  },
};

export default function ContactoPage() {
  const { pathname } = useLocation();
  const locale = isEnglishPath(pathname) ? 'en' : 'es';
  const t = TEXT[locale];
  const path = locale === 'en' ? '/en/contact' : '/contacto';

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'ContactPage',
    name: t.seoTitle,
    url: `https://innovation.valorizasm.com${path}`,
  };

  return (
    <>
      <SEOHead
        title={t.seoTitle}
        description={t.seoDescription}
        path={path}
        locale={locale}
        alternates={ALTERNATES}
        jsonLd={[jsonLd]}
      />
      <div className="pt-28 v-container" data-testid="contacto-page">
        <Breadcrumb items={t.breadcrumb} />
      </div>
      <ContactForm />
    </>
  );
}
